import { Container } from 'react-bootstrap';
import ChatWindow from '../../../../../components/chat/chat-window';
import { EnterGameButton } from '../../../../../components/enter-game-button';

export const Chat = () => {
  return (
    <>
      <Container className={'drawer__body px-3'} fluid>
        <ChatWindow />
      </Container>

      <EnterGameButton />
    </>
  );
};
